/**
 * @param placement
 */
export default function getVariation(placement) {
    return placement.split('-')[1];
}
//# sourceMappingURL=getVariation.js.map